import { i18n as tankerI18n } from '@ps-int/react-tanker';

import { getAppLang } from '../../../../utils/common-i18n';

/**
 * Возвращает перевод по переданным ключам и параметрам
 *
 * @param {string} keySet
 * @param {string} keyName
 * @param {Object|void} [params]
 * @returns {string}
 */
export const i18n = (keySet: string, keyName: string, params?: Record<string, string | number | boolean>): string => {
    const appLang = getAppLang();

    try {
        return tankerI18n(appLang, keySet, keyName, params);
    } catch {
        return '';
    }
};

export const i18nMonthsGenitive = (): string[] => i18n('lists', 'months-genitive').split(' | ');

export const i18nMonthsNominative = (): string[] => i18n('lists', 'months-nominative').split(' | ');

export const i18nWeekDays = (): string[] => i18n('lists', 'week-days').split(' | ');
